import React, { useRef, useState } from "react";
import { Row, Col, Select, Form, Input, InputNumber, Tooltip } from "antd";

import GenericModal from "../../../components/buttons/genericModal";
import { backendPostWithoutRefresh } from "../../../helpers/callBackend";
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';


const AddGeneralLedgerForm = (props) => {
	const [visible, setVisible] = useState(false);
	const [inFlight, setInFlight] = useState(false);
	const [accountType, setAccountType] = useState("");

	const [form] = Form.useForm();
	const formRef = useRef();
	formRef.current = form;

	const onFormSubmit = async (values) => {
		const url = accountType === "Header" ? "/api/general-ledger/header/" : "/api/general-ledger/account/";

		setInFlight(true);

		if (!values.total_into_account) {
			values.total_into_account = "";
		}

		try {
			let data = values;
			const res = await backendPostWithoutRefresh(url, data);

			const newLedger = res.data.data;

			props.addGeneralLedger(accountType, newLedger);

			if (formRef.current) {
				formRef.current.resetFields();
			}

			setInFlight(false);
			setVisible(false);
		} catch (err) {
			setInFlight(false);
		}
	};

	const { generalLedgerAccount, generalLedger } = props;

	return (
		<GenericModal
			visible={visible}
			handleCancelModal={() => {
				setVisible(false);
			}}
			showModal={() => {
				setVisible(true);
			}}
			size="md"
			button={<Button sx={{ fontSize: 14, textTransform: 'none' }} disableElevation fullWidth size="small" type="submit" variant="contained" color="primary">+ Add New</Button>}
			modalTitle={"Add New General Ledger"}
			modalBody={
				<Form layout="vertical" name="basic" onFinish={onFormSubmit} autoComplete="off" ref={formRef}>
					<Row gutter={16}>
						<Col span={6}>
							<Form.Item
								label="Code"
								name="code"
								placeholder="Code"
								rules={[
									{
										required: true,
										message: "Code is required",
									},
									{
										validator(_, value) {
											if (value && generalLedger.map((item) => item.code).includes(value)) {
												return Promise.reject(new Error("This code is already in use. Try another one!"));
											}

											if (value && (value < 1000 || value > 9999)) {
												return Promise.reject(new Error("Enter a code between 1000 and 9999"));
											}

											return Promise.resolve();
										},
									},
								]}
							>
								<InputNumber style={{ width: "100%" }} />
							</Form.Item>
						</Col>
						<Col span={18}>
							<Form.Item
								label="Description"
								name="description"
								placeholder="Description"
								rules={[
									{
										required: true,
										message: "Description is required",
									},
								]}
							>
								<Input />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={16}>
						<Col span={6}>
							<Form.Item
								label="Account Type"
								name="account_type"
								rules={[
									{
										required: true,
										message: "Account Type is required!",
									},
								]}
							>
								<Select
									onChange={(value) => {
										setAccountType(value);
									}}
									options={[
										{
											value: "TOT",
											label: "Total",
										},
										{
											value: "REG",
											label: "Regular",
										},
										{
											value: "Header",
											label: "Header",
										},
									]}
								/>
							</Form.Item>
						</Col>

						<Col span={18}>
							<Form.Item
								label="Report Type"
								name="report_type"
								rules={[
									{
										required: true,
										message: "Report Type is required!",
									},
								]}
							>
								<Select
									options={[
										{
											value: "BAL",
											label: "Balance Sheet",
										},
										{
											value: "INC",
											label: "Income Statement",
										},
									]}
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={16}>
						<Col span={6}>
							<Tooltip
								placement="topLeft"
								title={accountType === "Header" ? "Normal Balance and Total Into are not required for Header account type." : ""}
							>
								<Form.Item
									label="Normal Balance"
									name="normal_balance"
									rules={[
										{
											required: accountType === "Header" ? false : true,
											message: "Normal Balance is required",
										},
									]}
								>
									<Select
										options={[
											{
												value: "Credit",
												label: "Credit",
											},
											{
												value: "Debit",
												label: "Debit",
											},
										]}
										disabled={accountType === "Header"}
									/>
								</Form.Item>
							</Tooltip>
						</Col>

						<Col span={18}>
							<Tooltip
								placement="topLeft"
								title={accountType === "Header" ? "Normal Balance and Total Into are not required for Header account type." : ""}
							>
								<Form.Item label="Total Into" name="total_into_account">
									<Select
										showSearch
										allowClear
										options={generalLedgerAccount.map((item) => {
											return {
												value: item.description,
												label: item.description,
											};
										})}
										disabled={accountType === "Header"}
									/>
								</Form.Item>
							</Tooltip>
						</Col>
					</Row>

					<Form.Item>
						<LoadingButton
							sx={{ fontSize: 14, textTransform: 'none', width: '60px' }} disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
							loadingPosition="start" htmlType="submit" style={{ margin: "3px", width: "100%" }} loading={inFlight
						}>
							Submit
						</LoadingButton>
					</Form.Item>
				</Form>
			}
		/>
	);
};

export default AddGeneralLedgerForm;
